/* eslint-disable react/prop-types */
import { useState, useEffect } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
} from "reactstrap";

const rejectMessages = [
  {
    titulo: "CPF/CNPJ diferente",
    descricao: "CPF ou CNPJ estão diferentes do enviado, por favor reenvie!",
  },
  {
    titulo: "Documento ilegível",
    descricao:
      "O documento enviado está ilegível ou está cortado, por favor reenvie!",
  },

  {
    titulo: "Uso indevido do sistema",
    descricao: "Você foi desativado por ferir nossas políticas",
  },
];

function ModalMotivos({ isOpen, toggle, onConfirm, uid }) {
  const [tituloSelecionado, setTituloSelecionado] = useState("");
  const [tituloCustomizado, setTituloCustomizado] = useState("");
  const [descricao, setDescricao] = useState("");

  useEffect(() => {
    if (!isOpen) {
      setTituloSelecionado("");
      setTituloCustomizado("");
      setDescricao("");
    }
  }, [isOpen]);

  const handleSelectChange = (e) => {
    const titulo = e.target.value;
    setTituloSelecionado(titulo);
    
    if (titulo !== "Outros") {
      const item = rejectMessages.find((msg) => msg.titulo === titulo);
      setDescricao(item?.descricao || "");
    } else {
      setDescricao(""); 
      setTituloCustomizado(""); 
    }
  };

  const handleDescricaoChange = (e) => {
    setDescricao(e.target.value);
  };
  
  const handleTituloCustomizadoChange = (e) => {
    setTituloCustomizado(e.target.value);
  }

  const handleConfirm = () => {
    const tituloFinal = tituloSelecionado === 'Outros' ? tituloCustomizado : tituloSelecionado;
    
    if (descricao.trim() && tituloFinal.trim()) {
      onConfirm(uid, { titulo: tituloFinal, descricao });
      toggle(); 
    }
  };

  const isConfirmDisabled = !descricao.trim() || (tituloSelecionado === 'Outros' && !tituloCustomizado.trim());

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Motivo da Desativação</ModalHeader>
      <ModalBody>
        <FormGroup>
          <Label for="motivoSelect">Motivo</Label>
          {tituloSelecionado === 'Outros' ? (
            <Input
              type="text"
              id="motivoCustomizado"
              placeholder="Digite o título do motivo"
              value={tituloCustomizado}
              onChange={handleTituloCustomizadoChange}
              required
            />
          ) : (
            <Input
              type="select"
              id="motivoSelect"
              value={tituloSelecionado}
              onChange={handleSelectChange}
              required
            >
              <option value="">Selecione um motivo</option>
              {rejectMessages.map((msg, i) => (
                <option key={i} value={msg.titulo}>
                  {msg.titulo}
                </option>
              ))}
              <option value="Outros">Outros...</option>
            </Input>
          )}
        </FormGroup>

        <FormGroup>
          <Label for="descricao">Descrição</Label>
          <Input
            type="textarea"
            id="descricao"
            placeholder="Descreva detalhadamente o motivo da desativação."
            value={descricao}
            onChange={handleDescricaoChange}
            rows={4}
            required
          />
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="danger" onClick={handleConfirm} disabled={isConfirmDisabled}>
          Confirmar Desativação
        </Button>{" "}
        <Button color="secondary" onClick={toggle}>
          Cancelar
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default ModalMotivos;